import React, { useEffect, useState } from 'react';
import { api } from '../../../services/api.js';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import './RestauranteSelector.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as solidStar, faStarHalfAlt } from '@fortawesome/free-solid-svg-icons';
import { faStar as regularStar } from '@fortawesome/free-regular-svg-icons';

const RestauranteSelector = ({ usuario, onSelecionar, bloqueado }) => {
  const [restaurantes, setRestaurantes] = useState([]);
  const [erro, setErro] = useState(null);
  const chapa = localStorage.getItem("chapa");

  const renderStars = (nota) => {
    const rounded = Math.round(nota * 2) / 2;
    const full = Math.floor(rounded);
    const half = rounded % 1 !== 0;
    const empty = 5 - full - (half ? 1 : 0);
  
    const starClass = (i) => `text-warning me-1 star-blink`;
    const getDelay = (i) => ({ animationDelay: `${i * 0.2}s` });
  
    const stars = [];
  
    for (let i = 0; i < full; i++) {
      stars.push(
        <FontAwesomeIcon
          key={`full-${i}`}
          icon={solidStar}
          className={starClass(i)}
          style={getDelay(i)}
        />
      );
    }
  
    if (half) {
      stars.push(
        <FontAwesomeIcon
          key={`half`}
          icon={faStarHalfAlt}
          className={starClass(full)}
          style={getDelay(full)}
        />
      );
    }
  
    for (let i = 0; i < empty; i++) {
      stars.push(
        <FontAwesomeIcon
          key={`empty-${i}`}
          icon={regularStar}
          className={starClass(full + (half ? 1 : 0) + i)}
          style={getDelay(full + (half ? 1 : 0) + i)}
        />
      );
    }
  
    return <>{stars}</>;
  };

  useEffect(() => {
    const fetchRestaurantes = async () => {
      const lojaUsuario = localStorage.getItem("loja");
      try {
        const res = await api.get(`/restaurante/${chapa}?codigo=0&loja=${lojaUsuario}`);
        if (Array.isArray(res.data)) {
          setRestaurantes(res.data);
          setErro(null);
        } else {
          setErro('Dados inválidos recebidos do servidor.');
        }
      } catch (err) {
        console.error('Erro ao buscar restaurantes:', err);

        if (err.message === 'Network Error') {
          setErro('Falha no acesso ao servidor');
        } else if (err.response && err.response.data) {
          let mensagem = 'Erro inesperado';

          const data = err.response.data;

          mensagem = data.erro;


          setErro(`Erro: ${mensagem}`);
        } else {
          setErro('Erro inesperado ao buscar restaurantes.');
        }
      }
    };

    fetchRestaurantes();
  }, [usuario]);

  if (erro) {
    return (
      <div className="alert alert-danger" role="alert">
        {erro}
      </div>
    );
  }

  return (
    <div className="row">
      {restaurantes.map((rest) => (
        <div className="col-lg-3 col-md-3 col-sm-4 col-12" key={rest.codigo}>
          <div className={`card ${bloqueado ? 'bg-light' : 'bg-white'} shadow`}>
            <div className="card-body">
              <h5 className="card-title">{rest.nomeamigavel}</h5>
              <p className="card-text">Responsável: {rest.responsavel}</p>
              <p className="card-text">
                Avaliação:&nbsp;
                {rest.avaliacao != null ? (
                  <>
                    <span className="fw-bold">{Number(rest.avaliacao).toFixed(1)}</span>
                    &nbsp;
                    {renderStars(Number(rest.avaliacao))}
                  </>
                ) : (
                  'Sem avaliação'
                )}
              </p>
              <button
                className="btn btn-primary"
                disabled={bloqueado}
                onClick={() => onSelecionar(rest)}
              >
                Selecionar
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RestauranteSelector;
